
define('tmpl!core/templates/webidl/enum-item.html', ['deps/handlebars'], function (hb) { return hb.compile('{{idn indent}}"<a href="#idl-def-{{parentID}}.{{obj.refId}}" class="idlEnumItem">{{obj.id}}</a>"');});

